/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */

/**
 * Cette classe contient les constantes applicatives de la creation de comptes
 */
export class ConstantesCreationComptes {
  public static BANDEAU_PAGE = {
    TITRE: 'Je crée mon espace personnel',
  };
  public static PROFIL_INFO_TITRE = 'ESPACE PERSONNEL SÉCURISÉ';
  public static PROFIL_INFO_TEXT =
    'Vous devez créer votre propre compte pour pouvoir accéder à votre espace personnel.';

  public static PROFIL_INFO_TEXT2 =
    'Pour cela, vous devez suivre les étapes et compléter les différentes informations d’identité qui vous sont demandées.';

  public static CHOIX_IDENTIFIANT = {
    TITRE: 'Je choisis mon identifiant permanent',
    LABEL_VERIF_EMAIL: 'Vérifiez votre e-mail',
    INPUT_LABEL_EMAIL: 'Inscrivez votre e-mail',
    INFO_BULLE_1: {
      TITRE: 'Espace personnel sécurisé',
      TEXT: 'Vous devez créer votre propre compte pour pouvoir accéder à votre espace personnel.',
      TEXT2:
        'Pour cela, vous devez suivre les étapes et compléter les différentes informations d’identité qui vous sont demandées.',
    },
    INFO_BULLE_3: {
      TITRE: 'Compte personnel sécurisé',
      TEXT: 'Votre compte personnel sécurisé nécessite un identifiant qui peut être votre numéro de téléphone portable ou votre e-mail personnel.',
      TEXT2:
        'Vous recevrez un code de confirmation de votre identifiant  sur ce numéro ou cet e-mail.',
      TEXTALERT: 'Attention : les informations saisies vous engagent.',
    },
    INFO_BULLE_2: {
      TITRE: 'Regardez vos sms (ou vos e-mails)',
      TEXT: 'Après avoir cliqué sur "Je vérifie", vous recevrez un sms (ou un e-mail) sur votre portable (ou sur votre messagerie)',
    },
  };
  public static IDENTITE = {
    INFO_BULLE_1: {
      TITRE: 'Pourquoi transmettre mon identité ?',
      TEXT: 'Vous devez transmettre votre identité pour sécuriser la gestion de vos demandes et pour vous prémunir des risques de fraude.',
    },
    INFO_BULLE_2: {
      TITRE: 'Votre numéro d\'identité',
      TEXT: 'Saisissez correctement le numéro de votre document d\'identité.',
      ALERT: 'Attention, les informations saisies vous engagent.',
    },
  };

  public static CODE_VERIF_STATUT = {
    PROGRESS: 0,
    VALID: 1,
    ERROR: 2,
  };
}
